export class UserPropertyGroupType {
  public static readonly Details = "details"
  public static readonly List = "list"
}